import React, { Suspense, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { commonInfoDetailsData } from "src/atoms/commonInfoDetails.atoms";
import { loaderState } from "src/atoms/loader.atoms";
import { adminProfileState } from "src/atoms/profile.atoms";
import { roleModules } from "src/atoms/roleModules.atom";
import GlobalLoader from "src/components/shared/GlobalLoader/GlobalLoader";
import { CONSTANTS } from "src/constants";
import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import sidebarItems from "src/data/sidebar.data";
import { useCommonInfo } from "src/hooks/useCommonDetails";
import { ProfileProps } from "src/models/common.model";
import { CommonInfoDetails } from "src/models/commonInfoDetails.models";
import API_SERVICES from "src/services";
import handleResponse from "src/services/apiConfig/api.response.service";

import { CContainer } from "@coreui/react";

import Navbar from "../components/shared/NavBar/Navbar";
import Sidebar from "../components/shared/Sidebar/Sidebar";

import "react-toastify/dist/ReactToastify.css";
const AdminLayout: React.FC = () => {
  const { commonInfo, loading } = useCommonInfo();
  const [, setCommonInfoDetails] = useRecoilState<CommonInfoDetails>(
    commonInfoDetailsData
  );
  const userModules = useRecoilValue(roleModules);
  const profile = useRecoilValue<ProfileProps>(adminProfileState);
  const [, setLoader] = useRecoilState<boolean>(loaderState);
  const setProfile = useSetRecoilState<ProfileProps>(adminProfileState);
  const [allowedModules, setAllowedModules] = useState<string[]>([]);
  const [open, setOpen] = useState(CONSTANTS.COMMON_CONSTANTS.HIDE);
  const [showNavbar, setShowNavbar] = useState<boolean>(
    COMMON_CONSTANTS.TRUE_STATE_VARIABLE
  );
  const location = useLocation();

  useEffect(() => {
    getProfile();
  }, [location.pathname]);

  const getProfile = async () => {
    const res = await API_SERVICES.USER.ADMIN_PROFILE();
    const responseData = await handleResponse(res);
    setProfile(responseData?.data);
  };

  useEffect(() => {
    setCommonInfoDetails(commonInfo as CommonInfoDetails);
  }, [commonInfo]);

  useEffect(() => {
    setLoader(loading);
  }, [loading]);

  useEffect(() => {
    setAllowedModules(userModules.map(module => module.key));
  }, [userModules]);

  const handleNavbar = (): void => setShowNavbar(prevState => !prevState);

  return (
    <CContainer fluid className="px-0">
      <Sidebar
        className={`${open ? "dd-drawer-open" : ""} p-`}
        isOpen={showNavbar}
        setShowNavbar={setShowNavbar}
        sidebarItems={sidebarItems.filter(item => {
          if (item.superAdminOnly) {
            return Number(profile?.type) === CONSTANTS.SUPER_ADMIN;
          }
          return !item.moduleId || allowedModules.includes(item.moduleId);
        })}
      />
      <div className="wrapper">
        <Navbar ontoggleSidebar={handleNavbar} open={open} setOpen={setOpen} />
        <div
          className={`${open ? "dd-drawer-open" : ""} p-4 position-relative`}
        >
          <Suspense>
            <GlobalLoader />
            <Outlet />
          </Suspense>
        </div>
      </div>
    </CContainer>
  );
};

export default AdminLayout;
